import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { VolunteeringAreaService } from '../volunteering-area.service';
import { VolunteeringOverviewTab1Part } from './tabs/tab-1/volunteering-overview-tab-1.part';
import { VolunteeringOverviewTab2Part } from './tabs/tab-2/volunteering-overview-tab-2.part';
import { VolunteeringOverviewViewsPart } from './views/overview-views.part';
import { VolunteeringOverviewService } from './volunteering-overview.service';

@Component({
	selector: 'volunteering-overview-page',
	standalone: true,
	imports: [
		VolunteeringOverviewViewsPart,
		VolunteeringOverviewTab1Part,
		VolunteeringOverviewTab2Part,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-overview.page.html',
})
export class VolunteeringOverviewPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public areaService = inject(VolunteeringAreaService);
	public pageService = inject(VolunteeringOverviewService);
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}